import React, { useState } from "react";
import { CircularProgress, Box } from "@mui/material";

interface MainImageProps {
  image: any;
  index: number;
}

const MainImage: React.FC<MainImageProps> = ({ image, index }) => {
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  return (
    <Box
      sx={{
        position: "relative",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 5,
        overflow: "hidden",
        aspectRatio: 16 / 9
      }}
    >
      {!loaded && !errored && (
        <CircularProgress
          size={40}
          sx={{ position: "absolute", zIndex: 2, color: "var(--ums-accent-red)" }}
        />
      )}

      {!errored ? (
        <img
          src={image}
          alt={`Carousel ${index}`}
          draggable="false"
          onLoad={() => setLoaded(true)}
          onError={() => {
            setErrored(true);
            setLoaded(false);
          }}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: loaded ? "block" : "none",
          }}

        />
      ) : (
        <Box
          sx={{
            color: "#999",
            fontStyle: "italic",
            fontSize: "1rem",
            textAlign: "center",
          }}
        >
          Failed to load image
        </Box>
      )}
    </Box>
  );
};

export default MainImage;
